/* eslint-disable react/no-unescaped-entities */
import React, { FC, useState } from 'react';

import { setLocalItem } from '../../../utils/services/storage';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  SelectChangeEvent,
} from '@mui/material';
import { LOCATION } from '../../../utils/constants';
import { useNavigate } from 'react-router-dom';
import licensedStates from 'utils/constants/states';
import { useAuth } from 'utils/contexts/auth-context';
import MainButton from 'shared/components/button/main-button.component';

const SelectLocation: FC = () => {
  const navigate = useNavigate();
  const { setLocation, location } = useAuth();
  const [locationState, setLocationState] = useState<string>('');

  const handleOnChange = ({ target }: SelectChangeEvent<string>) => {
    setLocationState(target.value);
  };

  const handleSubmit = () => {
    setLocation(locationState);
    setLocalItem<string>(LOCATION, JSON.stringify(locationState));
    navigate('/', { replace: true });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography
        sx={{
          alignSelf: 'center',
          fontSize: '16px',
          marginBottom: '15px',
          marginLeft: '20px',
          width: '70%',
          color: 'secondary.contrastText',
        }}
      >
        Sorenson for Zoom brings live American Sign Language (ASL) interpreters
        to any meeting.
      </Typography>
      <Typography
        sx={{ fontSize: '18px', fontWeight: '600', marginBottom: '15px' }}
      >
        I'm located in
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <FormControl fullWidth>
          <Select
            labelId='location-select-label'
            id='location-select'
            value={locationState || ''}
            defaultValue='None'
            onChange={handleOnChange}
            MenuProps={{
              sx: {
                '.MuiList-root': {
                  bgcolor: 'white',
                  border: '1px solid',
                  borderColor: 'info.contrastText',
                },
              },
            }}
            sx={{
              marginBottom: '20px',
              borderRadius: '8px',
              '.MuiSelect-select': {
                backgroundColor: '#fff',
              },
            }}
          >
            {licensedStates.map(({ value, name }) => (
              <MenuItem value={value} key={value}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: '400',
            marginBottom: '15px',
            color: 'grey.600',
          }}
        >
          Choose the state where you are located
        </Typography>
      </Box>
      <Box sx={{ width: '100%' }}>
        <MainButton onClick={handleSubmit} type='submit'>
          Continue
        </MainButton>
      </Box>
    </Box>
  );
};

export default SelectLocation;
